// Calls the SignUp backend API. The browser holds no AWS credentials; the
// DynamoDB operations run in the backend (see backend/).
// REACT_APP_SIGNUP_API_URL is a public URL only, never a secret.
// `role` is 'trainee' or 'mentor' and selects the /trainee/* or /mentor/*
// backend routes.
const API_URL = (process.env.REACT_APP_SIGNUP_API_URL || '').replace(/\/+$/, '');

const post = async (path, body) => {
    const response = await fetch(`${API_URL}${path}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
        throw new Error(data.message || `Request failed with status ${response.status}`);
    }
    return data;
};

export const verifyHospital = (role, hospname) =>
    post(`/${role}/verify-hospital`, { hospname });

// Both roles; the record fields differ per role (see backend/src/roles.js).
export const createUserRecord = (role, record) =>
    post(`/${role}/create-user-record`, record);

export const checkUserLimit = (role, hospname, email) =>
    post(`/${role}/check-user-limit`, { hospname, email });
